/**
 * Web storage - uses localStorage (no AsyncStorage)
 */

const KEY_PREFIX = 'fvrad_';

async function getItem(key: string): Promise<string | null> {
  try {
    return (globalThis as any).window?.localStorage?.getItem(KEY_PREFIX + key) || null;
  } catch {
    return null;
  }
}

async function setItem(key: string, value: string): Promise<void> {
  try {
    (globalThis as any).window?.localStorage?.setItem(KEY_PREFIX + key, value);
  } catch {
    // ignore
  }
}

export const storage = { getItem, setItem };
